import React from 'react';
import { motion } from 'framer-motion';
import './Hero.css';
import heroImage from '../../assets/images/hero_fig.webp';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="container hero-container">
        <motion.div 
          className="hero-content"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h1><span className="highlight">Digital Fig</span></h1>
          <p className="hero-slogan">We'll fig-ure it out for you.</p>
          <h2>Enterprise Web Solutions & Software Development</h2>
          <p>
            Delivering high-performance digital solutions for businesses across industries.
            We specialise in creating exceptional web applications that drive growth and enhance your digital presence.
          </p>
          <div className="hero-buttons">
            <a href="#projects" className="btn primary-btn">Our Work</a>
            <a href="#contact" className="btn secondary-btn">Contact Us</a>
          </div>
        </motion.div>
        
        {/* Hero image with fade-in animation */}
        <motion.div 
          className="hero-image-container"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2 }}
        >
          <img src={heroImage} alt="Digital Fig illustration" className="hero-image" />
        </motion.div>
      </div>
      
    </section>
  );
};

export default Hero;